export default __webpack_public_path__ + "static/media/Asset 9.1f936934.svg";